// extracted by mini-css-extract-plugin
export default {"vote":"index_vote_LLw1E","voted":"index_voted_rGVg1"};